var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "inventory-item-sidesheet",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("remove-item-modal", {
        ref: "removeItemModal",
        on: { remove: _vm.onRemove },
      }),
      _c(
        "c-sidesheet",
        { attrs: { active: _vm.active }, on: { close: _vm.close } },
        [
          _c("div", { staticClass: "modal-frame" }, [
            _c(
              "div",
              { staticClass: "modal-wrapper" },
              [
                _c(
                  "shadow-scroll-container",
                  {
                    ref: "track",
                    staticClass: "modal-track",
                    attrs: { "with-top-scroller": true },
                  },
                  [
                    _c("div", { staticClass: "inventory-item-form" }, [
                      _c(
                        "div",
                        { staticClass: "inventory-item-form__wrapper" },
                        [
                          _c("div", { staticClass: "modal-frame__header" }, [
                            _c(
                              "h2",
                              { staticClass: "modal-frame__title" },
                              [
                                _vm.item
                                  ? [
                                      _vm._v(" Редактирование ТМЦ "),
                                      _c(
                                        "span",
                                        { staticClass: "inventory-item__name" },
                                        [
                                          _vm._v(
                                            "№" + _vm._s(_vm.item.serialNumber)
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [_vm._v(" Новая ТМЦ ")],
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticClass: "modal-frame__action" },
                              [
                                _vm.item && _vm.canRemove
                                  ? _c("c-button", {
                                      staticClass:
                                        "inventory-item-modal__remove",
                                      attrs: {
                                        size: "small",
                                        label: "Удалить",
                                        icon: {
                                          icon: "trash",
                                          color: "secondary",
                                        },
                                      },
                                      on: { click: _vm.remove },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass: "inventory-item-form__container",
                                },
                                [
                                  _c("c-loader", {
                                    staticClass:
                                      "inventory-items-table__loading",
                                    attrs: {
                                      active: true,
                                      label: "Данные загружаются",
                                      height: 200,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "inventory-item-form__container",
                                },
                                [
                                  !_vm.item
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col col-12" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__amount-type",
                                              },
                                              [
                                                _c("c-switcher", {
                                                  staticClass: "h-switcher",
                                                  attrs: {
                                                    items: _vm.amountTypes,
                                                    type: "group",
                                                  },
                                                  model: {
                                                    value: _vm.form.amountType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "amountType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.amountType",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.item
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-12 col-md-11 col-xl-4",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__category",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-input-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Категория/подкатегория ТМЦ"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.form.category
                                                        .formatLabel ||
                                                        _vm.form.category.label
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-12 col-md-11 col-xl-4",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__type",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-input-label",
                                                  },
                                                  [_vm._v("Тип ТМЦ")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.form.type.label
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-12 col-md-11 col-xl-6",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__category",
                                                class: {
                                                  "is-invalid":
                                                    _vm.isSubmitted &&
                                                    _vm.categoryError,
                                                },
                                              },
                                              [
                                                _c("c-input", {
                                                  attrs: {
                                                    type: "select",
                                                    items: _vm.categories,
                                                    searchable: true,
                                                    clearable: true,
                                                    "required-mark": true,
                                                    "with-categorized": true,
                                                    "floating-label":
                                                      "Категория/подкатегория ТМЦ",
                                                    required:
                                                      _vm.isSubmitted &&
                                                      _vm.categoryError,
                                                    "required-condition":
                                                      _vm.isSubmitted &&
                                                      _vm.categoryError,
                                                  },
                                                  model: {
                                                    value: _vm.form.category,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "category",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.category",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "catalog-link",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: "?r=redesign#/reference-uniform",
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Структура каталога ТМЦ"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-12 col-md-11 col-xl-4",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__type",
                                                class: {
                                                  "is-invalid":
                                                    _vm.isSubmitted &&
                                                    _vm.typeError,
                                                },
                                              },
                                              [
                                                _c("c-input", {
                                                  attrs: {
                                                    type: "select",
                                                    items: _vm.types,
                                                    searchable: true,
                                                    clearable: true,
                                                    disabled:
                                                      !_vm.form.category,
                                                    "required-mark": true,
                                                    "floating-label": "Тип ТМЦ",
                                                    required:
                                                      _vm.isSubmitted &&
                                                      _vm.typeError,
                                                    "required-condition":
                                                      _vm.isSubmitted &&
                                                      _vm.typeError,
                                                  },
                                                  model: {
                                                    value: _vm.form.type,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "type",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.type",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col col-12 col-md-8 col-xl-6",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group inventory-item-form__name",
                                          },
                                          [
                                            _c("c-input", {
                                              attrs: {
                                                "floating-label":
                                                  "Наименование",
                                                clearable: true,
                                                "max-length": 255,
                                              },
                                              model: {
                                                value: _vm.form.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm.form.amountType === "multiple"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-12 col-md-3 col-xl-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__amount",
                                                class: {
                                                  "is-invalid":
                                                    _vm.isSubmitted &&
                                                    _vm.amountError,
                                                },
                                              },
                                              [
                                                _c("c-input", {
                                                  attrs: {
                                                    type: "price-number",
                                                    "fractional-length": 0,
                                                    split: true,
                                                    "floating-label":
                                                      "Кол-во, шт",
                                                    "required-mark": true,
                                                    clearable: true,
                                                    required:
                                                      _vm.isSubmitted &&
                                                      _vm.amountError,
                                                    "required-condition":
                                                      _vm.isSubmitted &&
                                                      _vm.amountError,
                                                    "max-length": 11,
                                                  },
                                                  model: {
                                                    value: _vm.form.amount,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "amount",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.amount",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col col-12 col-md-3 col-xl-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group inventory-item-form__serial-number",
                                                class: {
                                                  "is-invalid":
                                                    _vm.isSubmitted &&
                                                    _vm.serialNumberError,
                                                },
                                              },
                                              [
                                                _c("c-input", {
                                                  attrs: {
                                                    "floating-label":
                                                      "Серийный номер",
                                                    clearable: true,
                                                    "max-length": 255,
                                                    required:
                                                      _vm.isSubmitted &&
                                                      _vm.serialNumberError,
                                                    "required-message":
                                                      _vm.isSubmitted &&
                                                      _vm.serialNumberError,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.serialNumber,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "serialNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.serialNumber",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col col-6 col-md-3 col-xl-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group inventory-item-form__expiration-date",
                                            class: {
                                              "is-invalid":
                                                _vm.isSubmitted &&
                                                _vm.expirationDateError,
                                            },
                                          },
                                          [
                                            _c("c-input", {
                                              ref: "expirationDate",
                                              staticClass:
                                                "inventory-item-expiration__field",
                                              attrs: {
                                                type: "date",
                                                label: "Срок годности",
                                                editable: true,
                                                clearable: true,
                                                format: "DD.MM.YYYY, dddd",
                                                placeholder: "00.00.0000",
                                                icon: "calendar",
                                                "icon-right": true,
                                                required:
                                                  _vm.isSubmitted &&
                                                  _vm.expirationDateError,
                                                "required-message":
                                                  _vm.isSubmitted &&
                                                  _vm.expirationDateError,
                                              },
                                              model: {
                                                value: _vm.form.expirationDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "expirationDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.expirationDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col col-6 col-md-3 col-xl-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group inventory-item-form__production-date",
                                            class: {
                                              "is-invalid":
                                                _vm.isSubmitted &&
                                                _vm.productionDateError,
                                            },
                                          },
                                          [
                                            _c("c-input", {
                                              ref: "productionDate",
                                              attrs: {
                                                label: "Дата производства",
                                                type: "date",
                                                editable: true,
                                                clearable: true,
                                                format: "DD.MM.YYYY, dddd",
                                                icon: "calendar",
                                                placeholder: "00.00.0000",
                                                "icon-right": true,
                                                required:
                                                  _vm.isSubmitted &&
                                                  _vm.productionDateError,
                                                "required-message":
                                                  _vm.isSubmitted &&
                                                  _vm.productionDateError,
                                              },
                                              model: {
                                                value: _vm.form.productionDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "productionDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.productionDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col col-6 col-md-3 col-xl-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group inventory-item-form__purchase-date",
                                            class: {
                                              "is-invalid":
                                                _vm.isSubmitted &&
                                                _vm.purchaseDateError,
                                            },
                                          },
                                          [
                                            _c("c-input", {
                                              ref: "purchaseDate",
                                              attrs: {
                                                label: "Дата покупки",
                                                type: "date",
                                                editable: true,
                                                clearable: true,
                                                format: "DD.MM.YYYY, dddd",
                                                icon: "calendar",
                                                placeholder: "00.00.0000",
                                                "icon-right": true,
                                                required:
                                                  _vm.isSubmitted &&
                                                  _vm.purchaseDateError,
                                                "required-message":
                                                  _vm.isSubmitted &&
                                                  _vm.purchaseDateError,
                                              },
                                              model: {
                                                value: _vm.form.purchaseDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "purchaseDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.purchaseDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "row align-items-end" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col col-12 col-md-8 col-xl-4",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group inventory-item-form__model",
                                            },
                                            [
                                              _c("c-input", {
                                                attrs: {
                                                  "floating-label": "Модель",
                                                  clearable: true,
                                                  "max-length": 255,
                                                },
                                                model: {
                                                  value: _vm.form.model,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "model",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.model",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col col-12 col-md-8 col-xl-4",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group inventory-item-form__purchasePlace",
                                            },
                                            [
                                              _c("c-input", {
                                                attrs: {
                                                  "floating-label":
                                                    "Где приобретено",
                                                  clearable: true,
                                                  "max-length": 255,
                                                },
                                                model: {
                                                  value: _vm.form.purchasePlace,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "purchasePlace",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.purchasePlace",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col col-12 col-md-3 col-xl-2",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-group inventory-item-form__cost",
                                            },
                                            [
                                              _c("c-input", {
                                                attrs: {
                                                  label:
                                                    _vm.form.amountType ===
                                                    "multiple"
                                                      ? "Примерная стоимость за шт., ฿"
                                                      : "Примерная стоимость, ฿",
                                                  type: "price-number",
                                                  "fractional-length": 0,
                                                  split: true,
                                                  clearable: true,
                                                  required:
                                                    _vm.isSubmitted &&
                                                    _vm.costError,
                                                  "required-condition":
                                                    _vm.isSubmitted &&
                                                    _vm.costError,
                                                  "max-length": 11,
                                                  placeholder: "0",
                                                },
                                                model: {
                                                  value: _vm.form.cost,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "cost",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.cost",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col col-12 col-md-11 col-xl-10",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-group inventory-item-form__description",
                                          },
                                          [
                                            _c("c-textarea", {
                                              attrs: {
                                                "floating-label": "Описание",
                                                clearable: true,
                                                "max-length": 500,
                                              },
                                              model: {
                                                value: _vm.form.description,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "description",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.description",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group inventory-item-form__files",
                                    },
                                    [
                                      _c("file-loader", {
                                        ref: "loader",
                                        attrs: {
                                          format: "all",
                                          actions: "loadFiles,preview",
                                          links: _vm.form.fileLinks,
                                          limit: 10,
                                        },
                                        on: {
                                          changeLinks: function ($event) {
                                            _vm.form.fileLinks = $event
                                          },
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "note",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "file-loader-note",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Допустимые форматы: .jpeg, .jpg, .gif, .png, видео: .mp4, .avi, .wmv, .mov, .3gp, .flv, .mpeg-1,2, .webm, документы:.doc, .pdf, .docx. Размер файла — не более 10Мб. "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.form.files,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "files", $$v)
                                          },
                                          expression: "form.files",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "inventory-item-form__actions",
                                      class: {
                                        fixed: _vm.fixActions,
                                      },
                                    },
                                    [
                                      _c("c-button", {
                                        staticClass:
                                          "inventory-item-form__reset",
                                        attrs: {
                                          size: "large",
                                          label: "Отменить",
                                        },
                                        on: { click: _vm.close },
                                      }),
                                      _c("c-button", {
                                        staticClass:
                                          "inventory-item-form__save",
                                        attrs: {
                                          label: _vm.saveButtonLabel,
                                          color: "primary",
                                          size: "large",
                                        },
                                        on: { click: _vm.submit },
                                      }),
                                      _c("observer", {
                                        staticClass: "footer-observer",
                                        on: {
                                          fullyVisible: function ($event) {
                                            _vm.fixActions = false
                                          },
                                          fullyHidden: function ($event) {
                                            _vm.fixActions = true
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "modal-actions" },
              [
                _c("c-button", {
                  attrs: { size: "large", label: "Отменить" },
                  on: { click: _vm.close },
                }),
                _c("c-button", {
                  attrs: {
                    label: _vm.saveButtonLabel,
                    color: "primary",
                    size: "large",
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }